module.exports = __webpack_public_path__ + "img/active-3.496dcfd1.jpg";